import { z } from 'zod';

/**
 * Zod schema for KheUoc (Loan/Contract) form
 *
 * This schema maps to the KheUocInput interface from types/schemas/khe-uoc.type.ts
 */
export const FormSchema = z.object({
  // Basic information
  ma_ku: z.string().min(1, 'Mã khế ước là bắt buộc'),
  ten_ku: z.string().min(1, 'Tên khế ước là bắt buộc'),
  ten_ku2: z.string().optional().nullable(),
  loai_ku: z.preprocess(val => (typeof val === 'string' ? parseInt(val) || 1 : val), z.number().default(1)),

  // Dates
  ngay_ku: z.string().min(1, 'Ngày lập là bắt buộc'),
  ngay_ku1: z.string().min(1, 'Ngày vay là bắt buộc'),
  ngay_ku2: z.string().min(1, 'Ngày đáo hạn là bắt buộc'),

  // Amounts
  tien_nt: z.preprocess(
    val => (typeof val === 'string' ? parseFloat(val) || 0 : val),
    z.number().min(0, 'Số tiền vay ngoại tệ không được âm')
  ),
  tien: z.preprocess(
    val => (typeof val === 'string' ? parseFloat(val) || 0 : val),
    z.number().min(0, 'Số tiền vay không được âm')
  ),

  // Status
  tinh_trang: z.preprocess(val => (typeof val === 'string' ? parseInt(val) || 1 : val), z.number().default(1)),
  status: z.preprocess(val => (typeof val === 'string' ? parseInt(val) || 1 : val), z.number().optional())
});

export type FormValues = z.infer<typeof FormSchema>;

export const initialFormValues: FormValues = {
  ma_ku: '',
  ten_ku: '',
  ten_ku2: null,
  loai_ku: 1,
  ngay_ku: '',
  ngay_ku1: '',
  ngay_ku2: '',
  tien_nt: 0,
  tien: 0,
  tinh_trang: 1,
  status: 1
};
